import React from "react";
import { getRequest, postRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";
import ResetIcon from "components/icons/ResetIcon"
import Modal from 'react-modal';

const { DateTime } = require("luxon");

class DigiDipMerchantData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            merchants: [],
            merchantsLoading: false,
            show: false,
            MerchantsTable: {
                title: "Affiliate merchants",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'merchantName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        this.getMerchants();
    };

    getMerchants = async () => {
        let url = `/api/Merchant/GetDigiDipMerchants`;

        this.setState({ merchantsLoading: true });

        try {
            const merchants = await getRequest(url);

            this.setState({
                merchants,
                merchantsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching merchants:", error);
            this.setState({ merchants: [], merchantsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    handleUpdateApproved = (id) => {
        this.setState({ merchantId: id, show: !this.state.show });
    }


    showModal = (e) => {
        e.preventDefault();
        this.setState({ show: !this.state.show });
    };

    hideModal = () => {
        this.setState({ show: false });
    };

    onRefreshYes = (e) => {
        e.preventDefault();

        this.updateDigiDipPorchApproved();

        this.setState({ show: false })
    };

    updateDigiDipPorchApproved = async () => {
        const merchantId = this.state.merchantId;

        let url = `/api/Merchant/UpdateDigiDipRockPorchApproved`;

        this.setState({ digiDipUpdating: true });

        try {
            var payload = { merchantId, apmId: this.props.affiliateProgramManager.id }
            var merchant = await postRequest(url, payload);

            // Update the specific merchant in the merchants array
            this.setState((prevState) => ({
                merchants: prevState.merchants.map(m =>
                    m.id === merchantId
                        ? { ...m, rockPorchApproved: !m.rockPorchApproved }
                        : m
                ),
                digiDipUpdating: false,
            }));
        } catch (error) {
            console.error("Error updating RockPorchApproved for merchantId " + merchantId + ".", error);
            this.setState({ digiDipUpdating: false });
        }
    };

    render() {
        const columns = [
            {
                name: "id",
                label: "Merchant ID",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ?? "-",
                },
            },
            {
                name: "digiDipMerchantId",
                label: "DigiDip Merchant ID",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ?? "-",
                },
            },
            {
                name: "rockPorchApproved",
                label: "RockPorch Approved",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const id = tableMeta.rowData?.[0];
                        return (
                            <div className="d-flex flex-column align-items-center" style={{ gap: "10px" }}>
                                <div className={`commission-status-${value ? "green" : "red"}`}>
                                    <div onClick={() => this.handleUpdateApproved(id)}>
                                        <ResetIcon
                                            height="12"
                                            width="12"
                                            pathStroke="#b3b3b3"
                                            style={{ position: "relative", left: "50%", transform: "translate(-50%, 4px)" }}
                                        />
                                    </div>
                                </div>
                                <p>{value ? "Yes" : "No"}</p>
                            </div>
                        );
                    },
                },
            },
            {
                name: "hostname",
                label: "Hostname",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ?? "-",
                },
            },
            {
                name: "merchantName",
                label: "Merchant Name",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ?? "-",
                },
            },
            {
                name: "homepage",
                label: "Homepage",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) =>
                        value ? <a href={value} target="_blank" rel="noopener noreferrer">{value}</a> : "-",
                },
            },
            {
                name: "cpa",
                label: "CPA",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ?? "-",
                },
            },
            {
                name: "cpl",
                label: "CPL",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ?? "-",
                },
            },
            {
                name: "cpc",
                label: "CPC",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ?? "-",
                },
            },
            {
                name: "customRate",
                label: "Custom Rate",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ?? "-",
                },
            },
            {
                name: "networkRate",
                label: "Network Rate",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value) => (
                        <div
                            style={{
                                maxHeight: "100px",
                                width: "400px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 5,
                                WebkitBoxOrient: "vertical",
                                wordBreak: "break-word",
                            }}
                            title={value}
                        >
                            {value ?? "-"}
                        </div>
                    ),
                },
            },
            {
                name: "exclusiveRate",
                label: "Exclusive Rate",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value) => (
                        <div
                            style={{
                                maxHeight: "100px",
                                width: "400px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 5,
                                WebkitBoxOrient: "vertical",
                                wordBreak: "break-word",
                            }}
                            title={value}
                        >
                            {value ?? "-"}
                        </div>
                    ),
                },
            },
            {
                name: "hosts",
                label: "Hosts",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value) => (
                        <div
                            style={{
                                maxHeight: "100px",
                                width: "300px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                wordBreak: "break-word",
                            }}
                            title={value}
                        >
                            {value ?? "-"}
                        </div>
                    ),
                },
            },
            {
                name: "countries",
                label: "Countries",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value) => (
                        <div
                            style={{
                                maxHeight: "100px",
                                width: "300px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                wordBreak: "break-word",
                            }}
                            title={value}
                        >
                            {value ?? "-"}
                        </div>
                    ),
                },
            },
            {
                name: "blockedProjects",
                label: "Blocked Projects",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value) => (
                        <div
                            style={{
                                maxHeight: "100px",
                                width: "300px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                wordBreak: "break-word",
                            }}
                            title={value}
                        >
                            {value ?? "-"}
                        </div>
                    ),
                },
            },
            {
                name: "href",
                label: "Href",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) =>
                        value ? <a href={value} target="_blank" rel="noopener noreferrer">{value}</a> : "-",
                },
            },
            {
                name: "createdBy",
                label: "Created By",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ?? "-",
                },
            },
            {
                name: "createdDate",
                label: "Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ? new Date(value).toLocaleString() : "-",
                },
            },
            {
                name: "modifiedBy",
                label: "Modified By",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ?? "-",
                },
            },
            {
                name: "modifiedDate",
                label: "Modified Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => value ? new Date(value).toLocaleString() : "-",
                },
            },
        ];

        return (
            <div>
                <Modal isOpen={this.state.show}
                    style={
                        {
                            overlay: {
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                zIndex: 9998,
                            },
                            content: {
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                border: '1px solid #ccc',
                                background: '#fff',
                                overflow: 'auto',
                                WebkitOverflowScrolling: 'touch',
                                borderRadius: '4px',
                                outline: 'none',
                                padding: '50px',
                                minWidth: '300px',
                                height: '550px',
                                zIndex: 1060,
                            }
                        }
                    }
                    onRequestClose={() => this.setState({ show: false })}
                >

                    <div className="d-flex flex-column justify-content-center h-100">
                        <div className="mx-0 my-0">
                            <h1 style={{ textAlign: "center", display: "block", fontSize: '1.75rem' }}>
                                Are you sure that you want to update the Approved Status for this merchant?
                            </h1>
                            <p style={{ textAlign: 'center', marginTop: "35px", fontWeight: "bold" }}>
                                NOTE: Updated status will may take a few minutes to proprogate through the RockPoch application even after the approval status changes color...
                            </p>
                        </div>

                        <div className="d-flex justify-content-center gap-3 mt-4">
                            <button type="button" className="btn btn-primary mr-2" onClick={(e) => this.onRefreshYes(e, this.state.merchantId)}>Yes</button>
                            <button type="button" className="btn btn-secondary ml-2" onClick={() => this.setState({ show: false })}>No</button>
                        </div>
                    </div>
                </Modal>
                <ThemeProvider theme={this.state.MerchantsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " merchants" ?? "No affiliate selected"}</p>
                            </div>
                        }
                        data={this.state.merchants ?? []}
                        columns={columns}
                        options={{
                            ...this.state.MerchantsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.merchantsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default DigiDipMerchantData;
